/* Fuerto — potvrzení po přidání do košíku (celý e-shop).
   Fuerto sekce posílají formulář natvrdo na /cart/add, což znamenalo
   reload na stránku košíku bez jakékoli zpětné vazby. Tady to bereme
   přes AJAX a ukážeme panel s přidaným produktem. */
(function () {
  var FREE_SHIPPING = 150000; /* haléře = 1 500 Kč */
  var panel, els = {};

  function money(cents) {
    return (cents / 100).toLocaleString('cs-CZ', { maximumFractionDigits: 0 }) + ' Kč';
  }

  function build() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'fz-cd';
    panel.setAttribute('hidden', '');
    panel.innerHTML =
      '<div class="fz-cd-ov" data-close></div>' +
      '<aside class="fz-cd-panel" role="dialog" aria-modal="true" aria-label="Přidáno do košíku">' +
        '<div class="fz-cd-head">' +
          '<span class="fz-cd-ok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Přidáno do košíku</span>' +
          '<button type="button" class="fz-cd-x" data-close aria-label="Zavřít">×</button>' +
        '</div>' +
        '<div class="fz-cd-item"><div class="fz-cd-thumb"><img alt=""></div>' +
          '<div class="fz-cd-meta"><div class="fz-cd-name"></div><div class="fz-cd-var"></div><div class="fz-cd-price"></div></div></div>' +
        '<div class="fz-cd-ship"></div>' +
        '<div class="fz-cd-sum"><span>Mezisoučet</span><strong class="fz-cd-total"></strong></div>' +
        '<div class="fz-cd-actions">' +
          '<button type="button" class="fz-cd-cont" data-close>Pokračovat v nákupu</button>' +
          '<a class="fz-cd-go" href="/cart">Přejít do košíku</a>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(panel);

    els.img = panel.querySelector('.fz-cd-thumb img');
    els.name = panel.querySelector('.fz-cd-name');
    els.vari = panel.querySelector('.fz-cd-var');
    els.price = panel.querySelector('.fz-cd-price');
    els.total = panel.querySelector('.fz-cd-total');
    els.ship = panel.querySelector('.fz-cd-ship');

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    return panel;
  }

  function open() {
    build().removeAttribute('hidden');
    setTimeout(function () { panel.classList.add('is-on'); }, 16);
    document.documentElement.classList.add('fz-cd-lock');
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-on');
    document.documentElement.classList.remove('fz-cd-lock');
    setTimeout(function () { if (panel && !panel.classList.contains('is-on')) panel.setAttribute('hidden', ''); }, 260);
  }

  /* Bublina s počtem v hlavičce. Když je košík prázdný, motiv ji vůbec
     nevykreslí — v tom případě ji vytvoříme. */
  function setCount(n) {
    var badges = document.querySelectorAll('.fz-hd-cartcount');
    if (!badges.length && n > 0) {
      document.querySelectorAll('a[href="/cart"]').forEach(function (a) {
        if (a.querySelector('svg')) {
          var s = document.createElement('span');
          s.className = 'fz-hd-cartcount';
          a.appendChild(s);
        }
      });
      badges = document.querySelectorAll('.fz-hd-cartcount');
    }
    badges.forEach(function (el) {
      el.textContent = n;
      el.style.display = n === 0 ? 'none' : '';
    });
  }

  function render(item, cart) {
    build();
    if (item.image) {
      els.img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
      els.img.alt = item.product_title || '';
      els.img.parentNode.style.display = '';
    } else {
      els.img.parentNode.style.display = 'none';
    }
    els.name.textContent = item.product_title || item.title || '';
    var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    els.vari.textContent = v;
    els.vari.style.display = v ? '' : 'none';
    els.price.textContent = money(item.final_line_price != null ? item.final_line_price : item.final_price);
    els.total.textContent = money(cart.total_price);

    var missing = FREE_SHIPPING - cart.total_price;
    if (missing > 0) {
      els.ship.textContent = 'Do dopravy zdarma zbývá ' + money(missing) + '.';
      els.ship.className = 'fz-cd-ship';
    } else {
      els.ship.textContent = 'Máš dopravu zdarma.';
      els.ship.className = 'fz-cd-ship is-ok';
    }
  }

  function fail(btn, msg) {
    if (!btn) { alert(msg); return; }
    var old = btn._fzHtml || btn.innerHTML;
    btn.textContent = msg;
    setTimeout(function () { btn.innerHTML = old; }, 2600);
  }

  function submit(form, btn) {
    var data = new FormData(form);
    if (btn) {
      btn.dataset.fzLabel = btn.textContent;
      btn._fzHtml = btn.innerHTML;
      btn.textContent = 'Přidávám…';
      btn.disabled = true;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Chyba');
        var item = res.j.items ? res.j.items[0] : res.j;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            setCount(cart.item_count);
            render(item, cart);
            open();
            document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
          });
      })
      .catch(function (e) { fail(btn, e.message || 'Nepodařilo se přidat'); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          if (btn._fzHtml && btn.textContent === 'Přidávám…') btn.innerHTML = btn._fzHtml;
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    /* stopPropagation: jinak formulář odeslal i skript v hlavičce (a u Impact šablon i product-form) → 2 ks místo 1 */
    e.preventDefault();
    e.stopPropagation();
    submit(form, form.querySelector('button[type=submit], .atc, .fz-card-add-btn'));
  }, true);
})();
